import { CharacterType, CharacterCase, Language } from '../../types/enums';
import getSvgPath from './get-svg-path';
import isDemoVersion from 'utils/is-demo-version';

const _englishLetters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const _spanishLetters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'Ñ',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const _numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

const getCharacters = (language, characterType, characterCase) => {
  if (characterType === CharacterType.NUMBER) return _numbers;

  if (language === Language.ENGLISH) {
    return characterCase === CharacterCase.UPPERCASE
      ? _englishLetters
      : _englishLetters.map((l) => l.toLowerCase());
  }

  return characterCase === CharacterCase.UPPERCASE
    ? _spanishLetters
    : _spanishLetters.map((l) => l.toLowerCase());
};

const isDemoCharacter = (language, characterType, characterCase, character) => {
  if (language === Language.SPANISH) return false;

  if (characterType === CharacterType.NUMBER) return ['5'].includes(character);

  if (characterType === CharacterType.PRINT) {
    return characterCase === CharacterCase.UPPERCASE
      ? ['E', 'R'].includes(character)
      : ['a', 'n'].includes(character);
  }

  if (characterType === CharacterType.CURSIVE) {
    return characterCase === CharacterCase.UPPERCASE
      ? ['A', 'P'].includes(character)
      : ['g', 'v'].includes(character);
  }
};

const CharSets = (language, characterType, characterCase) =>
  getCharacters(language, characterType, characterCase).map((character) => ({
    characterType,
    characterCase,
    character,
    svgPath: getSvgPath(characterType, characterCase, character),
    enabled: isDemoVersion()
      ? isDemoCharacter(language, characterType, characterCase, character)
      : true,
  }));

export default CharSets;
